var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "300px",
    width: "300px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m13 3c-5.511 0-10 4.489-10 10 0 5.511 4.489 10 10 10 2.3965 0 4.5974-0.85101 6.3223-2.2637l7.9707 7.9707a1.0001 1.0001 0 1 0 1.4141 -1.4141l-7.9707-7.9707c1.4127-1.7249 2.2637-3.9258 2.2637-6.3223 0-5.511-4.489-10-10-10zm0 2c4.4301 0 8 3.5699 8 8 0 4.4301-3.5699 8-8 8-4.4301 0-8-3.5699-8-8 0-4.4301 3.5699-8 8-8z",
    clipRule: "nonzero",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    fillRule: "nonzero",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifying);
export default __webpack_public_path__ + "static/media/magnifying.85a5fd56073084f94e96d708e6399cef.svg";
export { ForwardRef as ReactComponent };